
import CMSImage, { FilmwebCMSImage } from "@/components/image/CMSImage";
import getDocumentUrl from "@/lib/getDocumentUrl";
import { type FilmomtaleDocument, type NewsDocument } from "@/sanity/types/DeRefImageField";
import { FilmwebNews } from "@/sanity/types/filmwebSanityTypes";
import cn from "classnames";
import styles from "./WideImageTitle.module.css";
import Link from "next/link";




//#region [Props]
type CommonProps = {
    className?: string;
    subtitle?: string;
    size?: "small" | "large";
    order?: number;
}

type WideImageTitleBygdekinoenProps = {
    article: NewsDocument | FilmomtaleDocument | null | undefined;
    filmwebArticle?: never;
    imageRef: string | null | undefined;
} & CommonProps;

type WideImageTitleFilmwebProps = {
    filmwebArticle: FilmwebNews;
    article?: never;
    imageRef?: never;
} & CommonProps

type WideImageTitleProps = WideImageTitleBygdekinoenProps | WideImageTitleFilmwebProps;
//#endregion



//#region [Component]
export default function WideImageTitle({ article, filmwebArticle, className, subtitle, size = "small", imageRef }: WideImageTitleProps) {
    if (!article && !filmwebArticle) {
        return null;
    }
    const url = getDocumentUrl((article ?? filmwebArticle)!);
    const imgsize = size === "small" ? 400 : 800;

    return <article className={cn(styles.WideImageTitle, styles[size], className)}>
        {article && <Link href={url}>
            {!imageRef && <CMSImage className={styles.ArticleImage} image={article.image} width={imgsize} />}
            {imageRef && <FilmwebCMSImage className={styles.ArticleImage} assetRef={imageRef} width={imgsize} altText={article.title} />}
        </Link>}
        {filmwebArticle && <Link href={url}><FilmwebCMSImage className={styles.ArticleImage} assetRef={filmwebArticle.imageV2[0].asset._id} width={imgsize} altText={filmwebArticle.imageV2[0].asset.altText ?? filmwebArticle.title} /></Link>}
        <header className={styles.ArticleHeader}>
            <h1 className={styles.ArticleTitle}><Link href={url}>{article ? article.title : filmwebArticle!.title}</Link></h1>
            {subtitle && <p><Link href={url}>{subtitle}</Link></p>}
        </header>
    </article>;
}
//#endregion

//#region [Styles]

//#endregion